/* ============================================================
   DUSK & RELIC — minimal interaction layer (namespaced, no deps)
   - reveal-on-scroll for [data-reveal]
   - transparent header condenses to solid past a scroll threshold
   - mobile menu overlay open / close
   Degrades gracefully: if this never runs, content stays visible.
   ============================================================ */
(function () {
  document.documentElement.classList.add('dnr-js');

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    /* ---- reveal on scroll ---- */
    var reveals = document.querySelectorAll('.dnr [data-reveal]');
    if (reveals.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('in'); });
    }

    /* ---- header condense ---- */
    var headers = document.querySelectorAll('[data-dnr-header]');
    if (headers.length) {
      var onScroll = function () {
        var solid = (window.pageYOffset || document.documentElement.scrollTop) > 24;
        headers.forEach(function (h) { h.classList.toggle('is-solid', solid); });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---- mobile menu overlay ---- */
    function setMenu(overlay, open) {
      if (!overlay) return;
      overlay.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
      document.querySelectorAll('[data-dnr-menu-open]').forEach(function (b) {
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    document.querySelectorAll('[data-dnr-menu-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMenu(document.querySelector(btn.getAttribute('data-dnr-menu-open')), true);
      });
    });
    document.querySelectorAll('[data-dnr-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setMenu(document.querySelector(btn.getAttribute('data-dnr-menu-close')), false);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.dnr-overlay.is-open').forEach(function (o) { setMenu(o, false); });
      }
    });
  });
})();
